import React from 'react'
import cls from 'classnames';
import { Checkbox, CheckboxProps } from '.';

interface Props extends CheckboxProps {
  label: React.ReactNode;
  containerClassName?: string;
}

/**
 * A checkbox with a label.
 * @author Johan Svensson
 */
export const CheckboxField: React.FC<Props> = (props) => (
  <div
    className={cls([
      cls({
        "checkbox-field": true,
        "disabled": props.disabled
      }),
      props.containerClassName
    ])}>
    <label className="label">
      <Checkbox
        checked={props.checked}
        onChange={props.onChange}
        {...props}
      />
      {props.label}
    </label>
  </div >
);